import { render, staticRenderFns } from "./CurrentMilestonePopup.vue?vue&type=template&id=5831a325&scoped=true&"
import script from "./CurrentMilestonePopup.vue?vue&type=script&lang=js&"
export * from "./CurrentMilestonePopup.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMilestonePopup.vue?vue&type=style&index=0&id=5831a325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831a325",
  null
  
)

export default component.exports